// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.main-page[data-v-bb2863fe],.test[data-v-bb2863fe]{display:flex;flex-direction:column;align-items:center;justify-content:center}.test[data-v-bb2863fe]{width:500px;background-color:#fafad2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
